import myData from '../_json/chinese.json';
export default function Messages (){
    const allMessages = myData
    return allMessages
}